import { render, staticRenderFns } from "./DonglingPatientInfoTable.vue?vue&type=template&id=0885c258&scoped=true"
import script from "./DonglingPatientInfoTable.vue?vue&type=script&lang=js"
export * from "./DonglingPatientInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885c258",
  null
  
)

export default component.exports